
      // Parse chatId from url
      const urlParams = new URLSearchParams(window.location.search);
      const chatId = urlParams.get('chatId');

      // Create web component
      var chatbotElement = document.createElement('kanbu-chatbot');
      chatbotElement.setAttribute('chat', chatId);
      chatbotElement.setAttribute('opened', '');
      document.body.append(chatbotElement);
    